import { useDispatch } from "react-redux";
import { modalActions } from "../../storage/modals";

const RPMPlus = (props) => {
  const dispatch = useDispatch();

  const addToCart = (id) => {
    dispatch(modalActions.showAddToCartModal(id));
  };

  return (
    <section className="rpmplus" style={{background: `${props.content.bg} no-repeat center center/cover`}}>
      <div className="container">
        <div className="rpmplus-wrapper">
          <div className="rpmplus-image">
            <img
              src={props.content.icon}
              className="rpmplus-image__src"
              alt="Подписка RPM+"
            />
          </div>
          <div className="rpmplus-content">
            <h3 className="rpmplus-content__title">Подписка RPM+</h3>
            <p className="rpmplus-content__description">
              10+ уникальных возможностей, значительно дополняющих игровой
              процесс
            </p>
            <button
              type="button"
              className="rpmplus-content__info"
              onClick={() => {
                addToCart(props.content.products[0].id);
              }}
            >
              Полное описание преимуществ
            </button>
            <div className="rpmplus-options-label">
              <span className="rpmplus-options-label__title">
                варианты подписки
              </span>
            </div>
            <div className="rpmplus-buy-wrapper">
              {props.content.products.map((item) => (
                <button
                  type="button"
                  className="rpmplus-buy"
                  onClick={() => {
                    addToCart(item.id);
                  }}
                  key={item.id}
                >
                  <span className="rpmplus-buy__title">{item.period}</span>
                  <span className="rpmplus-buy__price">
                    {item.price} &#8381;
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RPMPlus;
